"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var currency_js_1 = __importDefault(require("currency.js"));
var react_1 = __importStar(require("react"));
var react_loading_skeleton_1 = __importDefault(require("react-loading-skeleton"));
var react_query_1 = require("react-query");
var to_title_case_1 = __importDefault(require("to-title-case"));
var selected_variant_state_1 = require("../../misc/selected-variant-state");
var ts_utils_1 = require("../../misc/ts-utils");
var ingredients_1 = require("../../utils/ingredients");
var app_1 = __importStar(require("../feature-tabs/app"));
var default_usage_1 = __importDefault(require("../oos-signup/default-usage"));
var app_2 = __importDefault(require("../variant-selector/app"));
var ProductWithDetails = function (_a) {
    var _b, _c, _d;
    var product = _a.product, productUrl = _a.productUrl, className = _a.className, mainImageCover = _a.mainImageCover, bottomImageUrl = _a.bottomImageUrl, onDoneAddingToCart = _a.onDoneAddingToCart, hideLearnMoreLink = _a.hideLearnMoreLink;
    var selectedVariant = (0, selected_variant_state_1.useSelectedVariantStore)(function (state) { return state.variant; });
    var loadedImagesReducer = function (state, action) {
        switch (action.type) {
            case 'add':
                return __spreadArray(__spreadArray([], __read(state), false), [action.newSrc], false);
        }
    };
    var _e = __read((0, react_1.useReducer)(loadedImagesReducer, []), 2), loadedImages = _e[0], dispatchLoadedImages = _e[1];
    var ingredientsUrl = process.env.HB_INGREDIENTS_URI;
    if (!ingredientsUrl)
        throw new Error('HB_INGREDIENTS_URI is not set');
    var productDataQueryName = 'getProductData';
    // it's important that this query key match the query key of a query in altProductDataQueries so that our "prefetching" strategy works
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    var productDataQuery = (0, react_query_1.useQuery)([productDataQueryName, ingredientsUrl, selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.sku], function () { return (0, ingredients_1.getProductData)(ingredientsUrl, selectedVariant.sku); }, {
        enabled: !!selectedVariant,
        retry: 1,
    });
    var productData = (_b = productDataQuery.data) === null || _b === void 0 ? void 0 : _b.message;
    // Prefetch and cache data for other variants so that the user can quickly change their variant selection.
    // Use a query here so that we only ever run this function once for each product.
    var altProductDataQueries = (0, react_1.useMemo)(function () {
        var e_1, _a;
        var queries = [];
        var _loop_1 = function (variant) {
            // ignore the selected variant because we've already fetched it
            if ((selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.id) === variant.id)
                return "continue";
            var query = {
                queryKey: [productDataQueryName, ingredientsUrl, variant.sku],
                queryFn: function () {
                    // force browser to prefetch and cache this variant's image
                    if (variant.featured_image)
                        new Image().src = variant.featured_image.src;
                    // fetch this variant's product data
                    return (0, ingredients_1.getProductData)(ingredientsUrl, variant.sku);
                },
                // don't let pre-fetching compete with the requests for the default variant that the user is waiting to see
                enabled: !productDataQuery.isLoading && loadedImages.length > 0,
                retry: false,
            };
            queries.push(query);
        };
        try {
            for (var _b = __values(product.variants), _c = _b.next(); !_c.done; _c = _b.next()) {
                var variant = _c.value;
                _loop_1(variant);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return queries;
    }, [ingredientsUrl, loadedImages.length, product.variants, productDataQuery.isLoading, selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.id]);
    // Don't need to do anything with this; we're just prefetching
    (0, react_query_1.useQueries)(altProductDataQueries);
    var tabs = (0, react_1.useMemo)(function () {
        var localTabs = [];
        if ((productData === null || productData === void 0 ? void 0 : productData.features) && productData.features.length > 0) {
            // FeatureTabsApp expects a semicolon-separated string
            localTabs.push({ title: 'Benefits', type: 'check', content: productData === null || productData === void 0 ? void 0 : productData.features.join(';') });
        }
        if ((productData === null || productData === void 0 ? void 0 : productData.madeWithout) && productData.madeWithout.length > 0) {
            // FeatureTabsApp expects a semicolon-separated string
            localTabs.push({ title: 'Made Without', type: 'x', content: productData === null || productData === void 0 ? void 0 : productData.madeWithout.join(';') });
        }
        return localTabs;
    }, [productData === null || productData === void 0 ? void 0 : productData.features, productData === null || productData === void 0 ? void 0 : productData.madeWithout]);
    // we should never be allowed to hit this but
    if (!selectedVariant)
        return null;
    var supplementFactImage = ((_c = productData === null || productData === void 0 ? void 0 : productData.supplementFactsUrl) === null || _c === void 0 ? void 0 : _c.length) || 0 > 0 ? productData === null || productData === void 0 ? void 0 : productData.supplementFactsUrl : undefined;
    // only show pricing if product price is non-zero
    // non-zero means free/part of a bundle (e.g. vitamin bundle)
    var shouldShowPrice = !!selectedVariant.price && selectedVariant.price !== 0;
    // we don't want to change the price based on the quantity on this component
    var QUANTITY = 1;
    var priceDisplay = (function () {
        var variantPrice = selectedVariant && Number(selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.price);
        return variantPrice && "$".concat((0, currency_js_1.default)(variantPrice).multiply(QUANTITY).toString());
    })();
    var compareAtPriceDisplay = (function () {
        var variantCompareAtPrice = selectedVariant && Number(selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.compare_at_price);
        return variantCompareAtPrice ? "$".concat((0, currency_js_1.default)(variantCompareAtPrice, { fromCents: true }).multiply(QUANTITY).toString()) : null;
    })();
    var selectedVariantTitle = selectedVariant.title !== 'Default Title' ? selectedVariant.title : undefined;
    // for some reason, product.featured_image doesn't include the "https:", so we have to add it here so that we can correctly compute showSkeleton
    var imgSrc = ((_d = selectedVariant.featured_image) === null || _d === void 0 ? void 0 : _d.src) || (product.featured_image ? "https:".concat(product.featured_image) : undefined);
    // Show a skeleton for the main image when either we haven't finished loading the image or the product data yet, so that we avoid displaying the image
    // before its background color is loaded and so that we avoid displaying the background color for the image before the image is loaded.
    // However, if we've already tried to load the product data twice, just show the image without the background color (it'll default to white).
    var showImgSkeleton = (imgSrc && !loadedImages.includes(imgSrc)) || (!productDataQuery.isSuccess && !productDataQuery.error);
    var imgObjectFit = mainImageCover ? 'cover' : 'contain';
    var definedIngredients = productData === null || productData === void 0 ? void 0 : productData.ingredients.filter(ts_utils_1.isTruthy);
    var ingredients = definedIngredients === null || definedIngredients === void 0 ? void 0 : definedIngredients.map(function (ingredient) { return (0, to_title_case_1.default)(ingredient.ingredientName); });
    return (react_1.default.createElement("div", { className: className },
        react_1.default.createElement("div", { className: 'product-with-details' },
            react_1.default.createElement("div", { className: 'container' },
                react_1.default.createElement("div", { style: { backgroundColor: !showImgSkeleton ? productData === null || productData === void 0 ? void 0 : productData.productHex : undefined, aspectRatio: '1.5/1' } },
                    showImgSkeleton && react_1.default.createElement(react_loading_skeleton_1.default, { height: '100%' }),
                    react_1.default.createElement("img", { src: imgSrc, style: { width: '100%', height: '100%', objectFit: imgObjectFit, display: showImgSkeleton ? 'none' : undefined }, alt: 'Product featured image', onLoad: function (value) { return dispatchLoadedImages({ type: 'add', newSrc: value.currentTarget.src }); } })),
                react_1.default.createElement("div", { className: 'padding-horizontal-4 padding-top-4' },
                    react_1.default.createElement("div", null,
                        react_1.default.createElement("div", { style: { fontSize: 25, fontWeight: 'bold' } }, product.title),
                        selectedVariantTitle && react_1.default.createElement("div", { className: 'text-brownish-grey' }, selectedVariantTitle),
                        react_1.default.createElement("div", { className: 'padding-top-2' }, !!(!productDataQuery.isSuccess && !productDataQuery.error) ? react_1.default.createElement(react_loading_skeleton_1.default, { count: 3 }) : react_1.default.createElement("div", { className: 'text-brownish-grey' }, productData === null || productData === void 0 ? void 0 : productData.description)),
                        shouldShowPrice && (react_1.default.createElement("div", { className: 'padding-top-2', style: { flexDirection: 'row' } },
                            priceDisplay,
                            compareAtPriceDisplay && react_1.default.createElement("span", { className: 'strike padding-left-2' }, compareAtPriceDisplay))),
                        (productData === null || productData === void 0 ? void 0 : productData.numServings) && (react_1.default.createElement("div", { className: 'padding-top-2', style: { flexDirection: 'row' } },
                            react_1.default.createElement("div", null,
                                productData.numServings,
                                " servings")))),
                    react_1.default.createElement(app_2.default, { product: product, modalSettings: { enableModal: false }, nonShoppableSiteSettings: { enabled: false }, pdpAddToCartSettings: {
                            hidePrice: true,
                            enableOutOfStockLogic: true,
                            onDoneAddingToCart: onDoneAddingToCart,
                        } }),
                    !selectedVariant.available && (react_1.default.createElement("div", { className: 'show-for-medium' },
                        react_1.default.createElement(default_usage_1.default, { variant: selectedVariant }))),
                    react_1.default.createElement("div", { className: 'padding-top-2' }),
                    !!(!productDataQuery.isSuccess && !productDataQuery.error) ? (react_1.default.createElement(react_loading_skeleton_1.default, { count: 6 })) : (react_1.default.createElement(react_1.default.Fragment, null,
                        supplementFactImage && (react_1.default.createElement("div", { style: { backgroundColor: productData === null || productData === void 0 ? void 0 : productData.productHex } },
                            react_1.default.createElement("div", { className: 'padding-horizontal-4' },
                                react_1.default.createElement("img", { src: "https:".concat(supplementFactImage), style: { width: '100%', height: '100%', objectFit: 'contain' }, alt: 'Supplement facts' })))),
                        tabs.length > 0 && (react_1.default.createElement("div", null, tabs.length > 1 ? (react_1.default.createElement("div", null,
                            react_1.default.createElement(app_1.default, { className: 'text-brownish-grey', tabs: tabs }))) : (tabs.length > 0 && (react_1.default.createElement("div", { className: 'padding-top-6' },
                            react_1.default.createElement("div", { style: { textAlign: 'center' } }, tabs[0].title),
                            react_1.default.createElement("div", { className: 'padding-horizontal-4 padding-top-3 space-y-2 text-brownish-grey font-size-14' }, (0, app_1.formatContent)(tabs[0].type, tabs[0].content))))))))),
                    ingredients && ingredients.length > 0 && (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("div", { className: 'margin-vertical-6', style: { borderBottom: '1px solid #cacaca' } }),
                        react_1.default.createElement("div", null,
                            react_1.default.createElement("div", { style: { textAlign: 'center' } }, "Ingredients"),
                            react_1.default.createElement("div", { className: 'padding-top-3 text-brownish-grey font-size-14' }, ingredients.join(', '))))),
                    bottomImageUrl && react_1.default.createElement("img", { className: 'padding-top-2', src: bottomImageUrl, alt: 'Modal bottom image' }),
                    !hideLearnMoreLink && (react_1.default.createElement("div", { className: 'padding-top-2 text-underline' },
                        react_1.default.createElement("a", { href: productUrl }, "Learn more"))))))));
};
exports.default = ProductWithDetails;
